<template>
  <div class="container">
    <div class="box">
      <recipe-form :id="id"></recipe-form>
    </div>
  </div>
</template>

<script>
import RecipeForm from './RecipeForm';

export default {
  name: 'edit-Recipe',
  props: ['id'],
  components: {
    RecipeForm,
  },
};

</script>



// WEBPACK FOOTER //
// src/components/recipe/EditRecipe.vue